'use client';

import { useRouter, useSelectedLayoutSegment } from 'next/navigation';

import { Container } from '@/app/components/layouts/container';
import { type TabItem, Tabs } from '@/app/components/navigation/tabs';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface Category {
  category: string;
  name: string;
  url: string;
  active: boolean;
}

interface CategoryTabsNavProps {
  categories: Category[];
  baseUrl: string;
  eventName?: string;
  testId?: string;
}

export const CategoryTabsNav = ({
  categories,
  baseUrl,
  eventName = 'special-offer',
  testId = 'special-offer',
}: CategoryTabsNavProps) => {
  const segment = useSelectedLayoutSegment();
  const router = useRouter();

  const selectedTab =
    segment && segment !== 'page' ? `${baseUrl}/${segment}` : baseUrl;

  const tabs: TabItem[] = categories.map((category) => ({
    value: category.url,
    label: category.name,
  }));

  const handleTabChange = (value: string) => {
    router.push(value);
  };

  return (
    <Container
      size="desktop-only"
      {...createDataAttributes({ test: `tabs-${testId}` })}
    >
      <Tabs
        variant="underline"
        value={selectedTab}
        items={tabs}
        overflowClassName={cn(
          'relative mb-8 before:absolute before:bottom-0 before:left-0 before:h-px before:w-full before:bg-gray-50 xl:mb-12'
        )}
        selectedTabClassName="text-red-500 before:border-red-500 hover:text-gray-900 hover:before:border-gray-900"
        tracking={{
          eventName,
        }}
        scrollToSelectedTab="center"
        onChange={handleTabChange}
      />
    </Container>
  );
};
